/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateRequestToPayInput = {
  id?: string | null,
  orderID?: string | null,
  expirationTime?: number | null,
  createdAt?: string | null,
  saleID?: string | null,
  creator?: string | null,
  customerID?: string | null,
};

export type ModelRequestToPayConditionInput = {
  orderID?: ModelIDInput | null,
  expirationTime?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  saleID?: ModelIDInput | null,
  creator?: ModelIDInput | null,
  customerID?: ModelIDInput | null,
  and?: Array< ModelRequestToPayConditionInput | null > | null,
  or?: Array< ModelRequestToPayConditionInput | null > | null,
  not?: ModelRequestToPayConditionInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type RequestToPay = {
  __typename: "RequestToPay",
  id: string,
  orderID?: string | null,
  expirationTime?: number | null,
  createdAt: string,
  saleID?: string | null,
  creator?: string | null,
  customerID?: string | null,
  updatedAt: string,
};

export type UpdateRequestToPayInput = {
  id: string,
  orderID?: string | null,
  expirationTime?: number | null,
  createdAt?: string | null,
  saleID?: string | null,
  creator?: string | null,
  customerID?: string | null,
};

export type DeleteRequestToPayInput = {
  id: string,
};

export type CreateSaleInput = {
  id?: string | null,
  username?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  branch?: string | null,
};

export type ModelSaleConditionInput = {
  username?: ModelStringInput | null,
  firstname?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  branch?: ModelStringInput | null,
  and?: Array< ModelSaleConditionInput | null > | null,
  or?: Array< ModelSaleConditionInput | null > | null,
  not?: ModelSaleConditionInput | null,
};

export type Sale = {
  __typename: "Sale",
  id: string,
  username?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  branch?: string | null,
  baskets?: ModelBasketConnection | null,
  customers?: ModelSaleCustomersConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelBasketConnection = {
  __typename: "ModelBasketConnection",
  items:  Array<Basket | null >,
  nextToken?: string | null,
};

export type Basket = {
  __typename: "Basket",
  id: string,
  basketID: string,
  saleID: string,
  createdAt: string,
  updatedAt: string,
};

export type ModelSaleCustomersConnection = {
  __typename: "ModelSaleCustomersConnection",
  items:  Array<SaleCustomers | null >,
  nextToken?: string | null,
};

export type SaleCustomers = {
  __typename: "SaleCustomers",
  id: string,
  saleID: string,
  customerID: string,
  sale: Sale,
  customer: Customer,
  createdAt: string,
  updatedAt: string,
};

export type Customer = {
  __typename: "Customer",
  id: string,
  customerID?: string | null,
  email?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  address?: ModelAddressConnection | null,
  taxInvoice?: ModelTaxInvoiceAddressConnection | null,
  phone_number?: string | null,
  basketID?: string | null,
  sales?: ModelSaleCustomersConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelAddressConnection = {
  __typename: "ModelAddressConnection",
  items:  Array<Address | null >,
  nextToken?: string | null,
};

export type Address = {
  __typename: "Address",
  id?: string | null,
  customerID: string,
  address?: string | null,
  district?: string | null,
  email?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  name?: string | null,
  phone?: string | null,
  postcode?: string | null,
  subDistrict?: string | null,
  province?: string | null,
  location?: Location | null,
  createdAt: string,
  updatedAt: string,
};

export type Location = {
  __typename: "Location",
  lat?: number | null,
  lng?: number | null,
};

export type ModelTaxInvoiceAddressConnection = {
  __typename: "ModelTaxInvoiceAddressConnection",
  items:  Array<TaxInvoiceAddress | null >,
  nextToken?: string | null,
};

export type TaxInvoiceAddress = {
  __typename: "TaxInvoiceAddress",
  id?: string | null,
  customerID: string,
  address?: string | null,
  district?: string | null,
  email?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  name?: string | null,
  phone?: string | null,
  postcode?: string | null,
  subDistrict?: string | null,
  province?: string | null,
  location?: Location | null,
  companyName?: string | null,
  companyBranch?: string | null,
  taxID?: string | null,
  isDefault?: boolean | null,
  requestTaxInvoice?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSaleInput = {
  id: string,
  username?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  branch?: string | null,
};

export type DeleteSaleInput = {
  id: string,
};

export type CreateBasketInput = {
  id?: string | null,
  basketID: string,
  saleID: string,
};

export type ModelBasketConditionInput = {
  basketID?: ModelIDInput | null,
  saleID?: ModelIDInput | null,
  and?: Array< ModelBasketConditionInput | null > | null,
  or?: Array< ModelBasketConditionInput | null > | null,
  not?: ModelBasketConditionInput | null,
};

export type UpdateBasketInput = {
  id: string,
  basketID?: string | null,
  saleID?: string | null,
};

export type DeleteBasketInput = {
  id: string,
};

export type CreateAddressInput = {
  id?: string | null,
  customerID: string,
  address?: string | null,
  district?: string | null,
  email?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  name?: string | null,
  phone?: string | null,
  postcode?: string | null,
  subDistrict?: string | null,
  province?: string | null,
  location?: LocationInput | null,
};

export type LocationInput = {
  lat?: number | null,
  lng?: number | null,
};

export type ModelAddressConditionInput = {
  customerID?: ModelIDInput | null,
  address?: ModelStringInput | null,
  district?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstname?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  name?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  postcode?: ModelStringInput | null,
  subDistrict?: ModelStringInput | null,
  province?: ModelStringInput | null,
  and?: Array< ModelAddressConditionInput | null > | null,
  or?: Array< ModelAddressConditionInput | null > | null,
  not?: ModelAddressConditionInput | null,
};

export type UpdateAddressInput = {
  id: string,
  customerID?: string | null,
  address?: string | null,
  district?: string | null,
  email?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  name?: string | null,
  phone?: string | null,
  postcode?: string | null,
  subDistrict?: string | null,
  province?: string | null,
  location?: LocationInput | null,
};

export type DeleteAddressInput = {
  id: string,
};

export type CreateTaxInvoiceAddressInput = {
  id?: string | null,
  customerID: string,
  address?: string | null,
  district?: string | null,
  email?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  name?: string | null,
  phone?: string | null,
  postcode?: string | null,
  subDistrict?: string | null,
  province?: string | null,
  location?: LocationInput | null,
  companyName?: string | null,
  companyBranch?: string | null,
  taxID?: string | null,
  isDefault?: boolean | null,
  requestTaxInvoice?: boolean | null,
};

export type ModelTaxInvoiceAddressConditionInput = {
  customerID?: ModelIDInput | null,
  address?: ModelStringInput | null,
  district?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstname?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  name?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  postcode?: ModelStringInput | null,
  subDistrict?: ModelStringInput | null,
  province?: ModelStringInput | null,
  companyName?: ModelStringInput | null,
  companyBranch?: ModelStringInput | null,
  taxID?: ModelStringInput | null,
  isDefault?: ModelBooleanInput | null,
  requestTaxInvoice?: ModelBooleanInput | null,
  and?: Array< ModelTaxInvoiceAddressConditionInput | null > | null,
  or?: Array< ModelTaxInvoiceAddressConditionInput | null > | null,
  not?: ModelTaxInvoiceAddressConditionInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type UpdateTaxInvoiceAddressInput = {
  id: string,
  customerID?: string | null,
  address?: string | null,
  district?: string | null,
  email?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  name?: string | null,
  phone?: string | null,
  postcode?: string | null,
  subDistrict?: string | null,
  province?: string | null,
  location?: LocationInput | null,
  companyName?: string | null,
  companyBranch?: string | null,
  taxID?: string | null,
  isDefault?: boolean | null,
  requestTaxInvoice?: boolean | null,
};

export type DeleteTaxInvoiceAddressInput = {
  id: string,
};

export type CreateCustomerInput = {
  id?: string | null,
  customerID?: string | null,
  email?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  phone_number?: string | null,
  basketID?: string | null,
};

export type ModelCustomerConditionInput = {
  customerID?: ModelIDInput | null,
  email?: ModelIDInput | null,
  firstname?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  phone_number?: ModelIDInput | null,
  basketID?: ModelIDInput | null,
  and?: Array< ModelCustomerConditionInput | null > | null,
  or?: Array< ModelCustomerConditionInput | null > | null,
  not?: ModelCustomerConditionInput | null,
};

export type UpdateCustomerInput = {
  id: string,
  customerID?: string | null,
  email?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  phone_number?: string | null,
  basketID?: string | null,
};

export type DeleteCustomerInput = {
  id: string,
};

export type CreateDraftOrderInput = {
  id?: string | null,
  data?: string | null,
};

export type ModelDraftOrderConditionInput = {
  data?: ModelStringInput | null,
  and?: Array< ModelDraftOrderConditionInput | null > | null,
  or?: Array< ModelDraftOrderConditionInput | null > | null,
  not?: ModelDraftOrderConditionInput | null,
};

export type DraftOrder = {
  __typename: "DraftOrder",
  id: string,
  data?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateDraftOrderInput = {
  id: string,
  data?: string | null,
};

export type DeleteDraftOrderInput = {
  id: string,
};

export type CreateSaleStatInput = {
  id?: string | null,
  timestamp: number,
  granularity: Granularity,
  totalSaleVolume?: number | null,
  totalOrder?: number | null,
  totalCustomer?: number | null,
};

export enum Granularity {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  ALL = "ALL",
}


export type ModelSaleStatConditionInput = {
  totalSaleVolume?: ModelFloatInput | null,
  totalOrder?: ModelFloatInput | null,
  totalCustomer?: ModelFloatInput | null,
  and?: Array< ModelSaleStatConditionInput | null > | null,
  or?: Array< ModelSaleStatConditionInput | null > | null,
  not?: ModelSaleStatConditionInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type SaleStat = {
  __typename: "SaleStat",
  id: string,
  timestamp: number,
  granularity: Granularity,
  totalSaleVolume?: number | null,
  totalOrder?: number | null,
  totalCustomer?: number | null,
  sale?: Sale | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSaleStatInput = {
  id: string,
  timestamp: number,
  granularity: Granularity,
  totalSaleVolume?: number | null,
  totalOrder?: number | null,
  totalCustomer?: number | null,
};

export type DeleteSaleStatInput = {
  id: string,
  granularity: Granularity,
  timestamp: number,
};

export type CreateSaleCustomerStatInput = {
  id?: string | null,
  timestamp: number,
  granularity: Granularity,
  totalSaleVolume?: number | null,
  totalOrder?: number | null,
  productList?: Array< string | null > | null,
  orderList?: Array< string | null > | null,
  saleID?: string | null,
};

export type ModelSaleCustomerStatConditionInput = {
  totalSaleVolume?: ModelFloatInput | null,
  totalOrder?: ModelFloatInput | null,
  productList?: ModelStringInput | null,
  orderList?: ModelStringInput | null,
  saleID?: ModelIDInput | null,
  and?: Array< ModelSaleCustomerStatConditionInput | null > | null,
  or?: Array< ModelSaleCustomerStatConditionInput | null > | null,
  not?: ModelSaleCustomerStatConditionInput | null,
};

export type SaleCustomerStat = {
  __typename: "SaleCustomerStat",
  id: string,
  timestamp: number,
  granularity: Granularity,
  totalSaleVolume?: number | null,
  totalOrder?: number | null,
  productList?: Array< string | null > | null,
  orderList?: Array< string | null > | null,
  saleID?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSaleCustomerStatInput = {
  id: string,
  timestamp: number,
  granularity: Granularity,
  totalSaleVolume?: number | null,
  totalOrder?: number | null,
  productList?: Array< string | null > | null,
  orderList?: Array< string | null > | null,
  saleID?: string | null,
};

export type DeleteSaleCustomerStatInput = {
  id: string,
  granularity: Granularity,
  timestamp: number,
};

export type CreateCustomerStatInput = {
  id?: string | null,
  timestamp: number,
  granularity: Granularity,
  totalSaleVolume?: number | null,
  totalOrder?: number | null,
  productList?: Array< string | null > | null,
  orderList?: Array< string | null > | null,
};

export type ModelCustomerStatConditionInput = {
  totalSaleVolume?: ModelFloatInput | null,
  totalOrder?: ModelFloatInput | null,
  productList?: ModelStringInput | null,
  orderList?: ModelStringInput | null,
  and?: Array< ModelCustomerStatConditionInput | null > | null,
  or?: Array< ModelCustomerStatConditionInput | null > | null,
  not?: ModelCustomerStatConditionInput | null,
};

export type CustomerStat = {
  __typename: "CustomerStat",
  id: string,
  timestamp: number,
  granularity: Granularity,
  totalSaleVolume?: number | null,
  totalOrder?: number | null,
  productList?: Array< string | null > | null,
  orderList?: Array< string | null > | null,
  customer?: Customer | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCustomerStatInput = {
  id: string,
  timestamp: number,
  granularity: Granularity,
  totalSaleVolume?: number | null,
  totalOrder?: number | null,
  productList?: Array< string | null > | null,
  orderList?: Array< string | null > | null,
};

export type DeleteCustomerStatInput = {
  id: string,
  granularity: Granularity,
  timestamp: number,
};

export type CreateOrderIDInput = {
  key: string,
  counter: number,
  lastEdited: number,
};

export type ModelOrderIDConditionInput = {
  counter?: ModelIntInput | null,
  lastEdited?: ModelIntInput | null,
  and?: Array< ModelOrderIDConditionInput | null > | null,
  or?: Array< ModelOrderIDConditionInput | null > | null,
  not?: ModelOrderIDConditionInput | null,
};

export type OrderID = {
  __typename: "OrderID",
  key: string,
  counter: number,
  lastEdited: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateOrderIDInput = {
  key: string,
  counter?: number | null,
  lastEdited?: number | null,
};

export type DeleteOrderIDInput = {
  key: string,
};

export type CreateSaleCustomersInput = {
  id?: string | null,
  saleID: string,
  customerID: string,
};

export type ModelSaleCustomersConditionInput = {
  saleID?: ModelIDInput | null,
  customerID?: ModelIDInput | null,
  and?: Array< ModelSaleCustomersConditionInput | null > | null,
  or?: Array< ModelSaleCustomersConditionInput | null > | null,
  not?: ModelSaleCustomersConditionInput | null,
};

export type UpdateSaleCustomersInput = {
  id: string,
  saleID?: string | null,
  customerID?: string | null,
};

export type DeleteSaleCustomersInput = {
  id: string,
};

export type Order = {
  __typename: "Order",
  orderId?: string | null,
};

export type ModelRequestToPayFilterInput = {
  id?: ModelIDInput | null,
  orderID?: ModelIDInput | null,
  expirationTime?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  saleID?: ModelIDInput | null,
  creator?: ModelIDInput | null,
  customerID?: ModelIDInput | null,
  and?: Array< ModelRequestToPayFilterInput | null > | null,
  or?: Array< ModelRequestToPayFilterInput | null > | null,
  not?: ModelRequestToPayFilterInput | null,
};

export type ModelRequestToPayConnection = {
  __typename: "ModelRequestToPayConnection",
  items:  Array<RequestToPay | null >,
  nextToken?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelSaleFilterInput = {
  id?: ModelIDInput | null,
  username?: ModelStringInput | null,
  firstname?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  branch?: ModelStringInput | null,
  and?: Array< ModelSaleFilterInput | null > | null,
  or?: Array< ModelSaleFilterInput | null > | null,
  not?: ModelSaleFilterInput | null,
};

export type ModelSaleConnection = {
  __typename: "ModelSaleConnection",
  items:  Array<Sale | null >,
  nextToken?: string | null,
};

export type ModelBasketFilterInput = {
  id?: ModelIDInput | null,
  basketID?: ModelIDInput | null,
  saleID?: ModelIDInput | null,
  and?: Array< ModelBasketFilterInput | null > | null,
  or?: Array< ModelBasketFilterInput | null > | null,
  not?: ModelBasketFilterInput | null,
};

export type ModelAddressFilterInput = {
  id?: ModelIDInput | null,
  customerID?: ModelIDInput | null,
  address?: ModelStringInput | null,
  district?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstname?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  name?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  postcode?: ModelStringInput | null,
  subDistrict?: ModelStringInput | null,
  province?: ModelStringInput | null,
  and?: Array< ModelAddressFilterInput | null > | null,
  or?: Array< ModelAddressFilterInput | null > | null,
  not?: ModelAddressFilterInput | null,
};

export type ModelTaxInvoiceAddressFilterInput = {
  id?: ModelIDInput | null,
  customerID?: ModelIDInput | null,
  address?: ModelStringInput | null,
  district?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstname?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  name?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  postcode?: ModelStringInput | null,
  subDistrict?: ModelStringInput | null,
  province?: ModelStringInput | null,
  companyName?: ModelStringInput | null,
  companyBranch?: ModelStringInput | null,
  taxID?: ModelStringInput | null,
  isDefault?: ModelBooleanInput | null,
  requestTaxInvoice?: ModelBooleanInput | null,
  and?: Array< ModelTaxInvoiceAddressFilterInput | null > | null,
  or?: Array< ModelTaxInvoiceAddressFilterInput | null > | null,
  not?: ModelTaxInvoiceAddressFilterInput | null,
};

export type ModelCustomerFilterInput = {
  id?: ModelIDInput | null,
  customerID?: ModelIDInput | null,
  email?: ModelIDInput | null,
  firstname?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  phone_number?: ModelIDInput | null,
  basketID?: ModelIDInput | null,
  and?: Array< ModelCustomerFilterInput | null > | null,
  or?: Array< ModelCustomerFilterInput | null > | null,
  not?: ModelCustomerFilterInput | null,
};

export type ModelCustomerConnection = {
  __typename: "ModelCustomerConnection",
  items:  Array<Customer | null >,
  nextToken?: string | null,
};

export type ModelDraftOrderFilterInput = {
  id?: ModelIDInput | null,
  data?: ModelStringInput | null,
  and?: Array< ModelDraftOrderFilterInput | null > | null,
  or?: Array< ModelDraftOrderFilterInput | null > | null,
  not?: ModelDraftOrderFilterInput | null,
};

export type ModelDraftOrderConnection = {
  __typename: "ModelDraftOrderConnection",
  items:  Array<DraftOrder | null >,
  nextToken?: string | null,
};

export type ModelSaleStatPrimaryCompositeKeyConditionInput = {
  eq?: ModelSaleStatPrimaryCompositeKeyInput | null,
  le?: ModelSaleStatPrimaryCompositeKeyInput | null,
  lt?: ModelSaleStatPrimaryCompositeKeyInput | null,
  ge?: ModelSaleStatPrimaryCompositeKeyInput | null,
  gt?: ModelSaleStatPrimaryCompositeKeyInput | null,
  between?: Array< ModelSaleStatPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelSaleStatPrimaryCompositeKeyInput | null,
};

export type ModelSaleStatPrimaryCompositeKeyInput = {
  granularity?: Granularity | null,
  timestamp?: number | null,
};

export type ModelSaleStatFilterInput = {
  id?: ModelIDInput | null,
  timestamp?: ModelIntInput | null,
  granularity?: ModelGranularityInput | null,
  totalSaleVolume?: ModelFloatInput | null,
  totalOrder?: ModelFloatInput | null,
  totalCustomer?: ModelFloatInput | null,
  and?: Array< ModelSaleStatFilterInput | null > | null,
  or?: Array< ModelSaleStatFilterInput | null > | null,
  not?: ModelSaleStatFilterInput | null,
};

export type ModelGranularityInput = {
  eq?: Granularity | null,
  ne?: Granularity | null,
};

export type ModelSaleStatConnection = {
  __typename: "ModelSaleStatConnection",
  items:  Array<SaleStat | null >,
  nextToken?: string | null,
};

export type ModelSaleStatByIDWithGranularityCompositeKeyConditionInput = {
  eq?: ModelSaleStatByIDWithGranularityCompositeKeyInput | null,
  le?: ModelSaleStatByIDWithGranularityCompositeKeyInput | null,
  lt?: ModelSaleStatByIDWithGranularityCompositeKeyInput | null,
  ge?: ModelSaleStatByIDWithGranularityCompositeKeyInput | null,
  gt?: ModelSaleStatByIDWithGranularityCompositeKeyInput | null,
  between?: Array< ModelSaleStatByIDWithGranularityCompositeKeyInput | null > | null,
  beginsWith?: ModelSaleStatByIDWithGranularityCompositeKeyInput | null,
};

export type ModelSaleStatByIDWithGranularityCompositeKeyInput = {
  granularity?: Granularity | null,
  timestamp?: number | null,
};

export type ModelSaleCustomerStatPrimaryCompositeKeyConditionInput = {
  eq?: ModelSaleCustomerStatPrimaryCompositeKeyInput | null,
  le?: ModelSaleCustomerStatPrimaryCompositeKeyInput | null,
  lt?: ModelSaleCustomerStatPrimaryCompositeKeyInput | null,
  ge?: ModelSaleCustomerStatPrimaryCompositeKeyInput | null,
  gt?: ModelSaleCustomerStatPrimaryCompositeKeyInput | null,
  between?: Array< ModelSaleCustomerStatPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelSaleCustomerStatPrimaryCompositeKeyInput | null,
};

export type ModelSaleCustomerStatPrimaryCompositeKeyInput = {
  granularity?: Granularity | null,
  timestamp?: number | null,
};

export type ModelSaleCustomerStatFilterInput = {
  id?: ModelIDInput | null,
  timestamp?: ModelIntInput | null,
  granularity?: ModelGranularityInput | null,
  totalSaleVolume?: ModelFloatInput | null,
  totalOrder?: ModelFloatInput | null,
  productList?: ModelStringInput | null,
  orderList?: ModelStringInput | null,
  saleID?: ModelIDInput | null,
  and?: Array< ModelSaleCustomerStatFilterInput | null > | null,
  or?: Array< ModelSaleCustomerStatFilterInput | null > | null,
  not?: ModelSaleCustomerStatFilterInput | null,
};

export type ModelSaleCustomerStatConnection = {
  __typename: "ModelSaleCustomerStatConnection",
  items:  Array<SaleCustomerStat | null >,
  nextToken?: string | null,
};

export type ModelSaleCustomerStatByIDWithGranularityCompositeKeyConditionInput = {
  eq?: ModelSaleCustomerStatByIDWithGranularityCompositeKeyInput | null,
  le?: ModelSaleCustomerStatByIDWithGranularityCompositeKeyInput | null,
  lt?: ModelSaleCustomerStatByIDWithGranularityCompositeKeyInput | null,
  ge?: ModelSaleCustomerStatByIDWithGranularityCompositeKeyInput | null,
  gt?: ModelSaleCustomerStatByIDWithGranularityCompositeKeyInput | null,
  between?: Array< ModelSaleCustomerStatByIDWithGranularityCompositeKeyInput | null > | null,
  beginsWith?: ModelSaleCustomerStatByIDWithGranularityCompositeKeyInput | null,
};

export type ModelSaleCustomerStatByIDWithGranularityCompositeKeyInput = {
  granularity?: Granularity | null,
  timestamp?: number | null,
};

export type ModelSaleCustomerStatBySaleIDWithGranularityAndTimestampCompositeKeyConditionInput = {
  eq?: ModelSaleCustomerStatBySaleIDWithGranularityAndTimestampCompositeKeyInput | null,
  le?: ModelSaleCustomerStatBySaleIDWithGranularityAndTimestampCompositeKeyInput | null,
  lt?: ModelSaleCustomerStatBySaleIDWithGranularityAndTimestampCompositeKeyInput | null,
  ge?: ModelSaleCustomerStatBySaleIDWithGranularityAndTimestampCompositeKeyInput | null,
  gt?: ModelSaleCustomerStatBySaleIDWithGranularityAndTimestampCompositeKeyInput | null,
  between?: Array< ModelSaleCustomerStatBySaleIDWithGranularityAndTimestampCompositeKeyInput | null > | null,
  beginsWith?: ModelSaleCustomerStatBySaleIDWithGranularityAndTimestampCompositeKeyInput | null,
};

export type ModelSaleCustomerStatBySaleIDWithGranularityAndTimestampCompositeKeyInput = {
  granularity?: Granularity | null,
  timestamp?: number | null,
};

export type ModelCustomerStatPrimaryCompositeKeyConditionInput = {
  eq?: ModelCustomerStatPrimaryCompositeKeyInput | null,
  le?: ModelCustomerStatPrimaryCompositeKeyInput | null,
  lt?: ModelCustomerStatPrimaryCompositeKeyInput | null,
  ge?: ModelCustomerStatPrimaryCompositeKeyInput | null,
  gt?: ModelCustomerStatPrimaryCompositeKeyInput | null,
  between?: Array< ModelCustomerStatPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelCustomerStatPrimaryCompositeKeyInput | null,
};

export type ModelCustomerStatPrimaryCompositeKeyInput = {
  granularity?: Granularity | null,
  timestamp?: number | null,
};

export type ModelCustomerStatFilterInput = {
  id?: ModelIDInput | null,
  timestamp?: ModelIntInput | null,
  granularity?: ModelGranularityInput | null,
  totalSaleVolume?: ModelFloatInput | null,
  totalOrder?: ModelFloatInput | null,
  productList?: ModelStringInput | null,
  orderList?: ModelStringInput | null,
  and?: Array< ModelCustomerStatFilterInput | null > | null,
  or?: Array< ModelCustomerStatFilterInput | null > | null,
  not?: ModelCustomerStatFilterInput | null,
};

export type ModelCustomerStatConnection = {
  __typename: "ModelCustomerStatConnection",
  items:  Array<CustomerStat | null >,
  nextToken?: string | null,
};

export type ModelCustomerStatByIDWithGranularityCompositeKeyConditionInput = {
  eq?: ModelCustomerStatByIDWithGranularityCompositeKeyInput | null,
  le?: ModelCustomerStatByIDWithGranularityCompositeKeyInput | null,
  lt?: ModelCustomerStatByIDWithGranularityCompositeKeyInput | null,
  ge?: ModelCustomerStatByIDWithGranularityCompositeKeyInput | null,
  gt?: ModelCustomerStatByIDWithGranularityCompositeKeyInput | null,
  between?: Array< ModelCustomerStatByIDWithGranularityCompositeKeyInput | null > | null,
  beginsWith?: ModelCustomerStatByIDWithGranularityCompositeKeyInput | null,
};

export type ModelCustomerStatByIDWithGranularityCompositeKeyInput = {
  granularity?: Granularity | null,
  timestamp?: number | null,
};

export type ModelOrderIDFilterInput = {
  key?: ModelIDInput | null,
  counter?: ModelIntInput | null,
  lastEdited?: ModelIntInput | null,
  and?: Array< ModelOrderIDFilterInput | null > | null,
  or?: Array< ModelOrderIDFilterInput | null > | null,
  not?: ModelOrderIDFilterInput | null,
};

export type ModelOrderIDConnection = {
  __typename: "ModelOrderIDConnection",
  items:  Array<OrderID | null >,
  nextToken?: string | null,
};

export type ModelSaleCustomersFilterInput = {
  id?: ModelIDInput | null,
  saleID?: ModelIDInput | null,
  customerID?: ModelIDInput | null,
  and?: Array< ModelSaleCustomersFilterInput | null > | null,
  or?: Array< ModelSaleCustomersFilterInput | null > | null,
  not?: ModelSaleCustomersFilterInput | null,
};

export type ModelSubscriptionRequestToPayFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  orderID?: ModelSubscriptionIDInput | null,
  expirationTime?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  saleID?: ModelSubscriptionIDInput | null,
  creator?: ModelSubscriptionIDInput | null,
  customerID?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionRequestToPayFilterInput | null > | null,
  or?: Array< ModelSubscriptionRequestToPayFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionSaleFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  username?: ModelSubscriptionStringInput | null,
  firstname?: ModelSubscriptionStringInput | null,
  lastname?: ModelSubscriptionStringInput | null,
  branch?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSaleFilterInput | null > | null,
  or?: Array< ModelSubscriptionSaleFilterInput | null > | null,
};

export type ModelSubscriptionBasketFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  basketID?: ModelSubscriptionIDInput | null,
  saleID?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionBasketFilterInput | null > | null,
  or?: Array< ModelSubscriptionBasketFilterInput | null > | null,
};

export type ModelSubscriptionAddressFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  customerID?: ModelSubscriptionIDInput | null,
  address?: ModelSubscriptionStringInput | null,
  district?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  firstname?: ModelSubscriptionStringInput | null,
  lastname?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  phone?: ModelSubscriptionStringInput | null,
  postcode?: ModelSubscriptionStringInput | null,
  subDistrict?: ModelSubscriptionStringInput | null,
  province?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAddressFilterInput | null > | null,
  or?: Array< ModelSubscriptionAddressFilterInput | null > | null,
};

export type ModelSubscriptionTaxInvoiceAddressFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  customerID?: ModelSubscriptionIDInput | null,
  address?: ModelSubscriptionStringInput | null,
  district?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  firstname?: ModelSubscriptionStringInput | null,
  lastname?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  phone?: ModelSubscriptionStringInput | null,
  postcode?: ModelSubscriptionStringInput | null,
  subDistrict?: ModelSubscriptionStringInput | null,
  province?: ModelSubscriptionStringInput | null,
  companyName?: ModelSubscriptionStringInput | null,
  companyBranch?: ModelSubscriptionStringInput | null,
  taxID?: ModelSubscriptionStringInput | null,
  isDefault?: ModelSubscriptionBooleanInput | null,
  requestTaxInvoice?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionTaxInvoiceAddressFilterInput | null > | null,
  or?: Array< ModelSubscriptionTaxInvoiceAddressFilterInput | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionCustomerFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  customerID?: ModelSubscriptionIDInput | null,
  email?: ModelSubscriptionIDInput | null,
  firstname?: ModelSubscriptionStringInput | null,
  lastname?: ModelSubscriptionStringInput | null,
  phone_number?: ModelSubscriptionIDInput | null,
  basketID?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionCustomerFilterInput | null > | null,
  or?: Array< ModelSubscriptionCustomerFilterInput | null > | null,
};

export type ModelSubscriptionDraftOrderFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  data?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDraftOrderFilterInput | null > | null,
  or?: Array< ModelSubscriptionDraftOrderFilterInput | null > | null,
};

export type ModelSubscriptionSaleStatFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  timestamp?: ModelSubscriptionIntInput | null,
  granularity?: ModelSubscriptionStringInput | null,
  totalSaleVolume?: ModelSubscriptionFloatInput | null,
  totalOrder?: ModelSubscriptionFloatInput | null,
  totalCustomer?: ModelSubscriptionFloatInput | null,
  and?: Array< ModelSubscriptionSaleStatFilterInput | null > | null,
  or?: Array< ModelSubscriptionSaleStatFilterInput | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionSaleCustomerStatFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  timestamp?: ModelSubscriptionIntInput | null,
  granularity?: ModelSubscriptionStringInput | null,
  totalSaleVolume?: ModelSubscriptionFloatInput | null,
  totalOrder?: ModelSubscriptionFloatInput | null,
  productList?: ModelSubscriptionStringInput | null,
  orderList?: ModelSubscriptionStringInput | null,
  saleID?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionSaleCustomerStatFilterInput | null > | null,
  or?: Array< ModelSubscriptionSaleCustomerStatFilterInput | null > | null,
};

export type ModelSubscriptionCustomerStatFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  timestamp?: ModelSubscriptionIntInput | null,
  granularity?: ModelSubscriptionStringInput | null,
  totalSaleVolume?: ModelSubscriptionFloatInput | null,
  totalOrder?: ModelSubscriptionFloatInput | null,
  productList?: ModelSubscriptionStringInput | null,
  orderList?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCustomerStatFilterInput | null > | null,
  or?: Array< ModelSubscriptionCustomerStatFilterInput | null > | null,
};

export type ModelSubscriptionOrderIDFilterInput = {
  key?: ModelSubscriptionIDInput | null,
  counter?: ModelSubscriptionIntInput | null,
  lastEdited?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionOrderIDFilterInput | null > | null,
  or?: Array< ModelSubscriptionOrderIDFilterInput | null > | null,
};

export type ModelSubscriptionSaleCustomersFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  saleID?: ModelSubscriptionIDInput | null,
  customerID?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionSaleCustomersFilterInput | null > | null,
  or?: Array< ModelSubscriptionSaleCustomersFilterInput | null > | null,
};

export type CreateRequestToPayMutationVariables = {
  input: CreateRequestToPayInput,
  condition?: ModelRequestToPayConditionInput | null,
};

export type CreateRequestToPayMutation = {
  createRequestToPay?:  {
    __typename: "RequestToPay",
    id: string,
    orderID?: string | null,
    expirationTime?: number | null,
    createdAt: string,
    saleID?: string | null,
    creator?: string | null,
    customerID?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateRequestToPayMutationVariables = {
  input: UpdateRequestToPayInput,
  condition?: ModelRequestToPayConditionInput | null,
};

export type UpdateRequestToPayMutation = {
  updateRequestToPay?:  {
    __typename: "RequestToPay",
    id: string,
    orderID?: string | null,
    expirationTime?: number | null,
    createdAt: string,
    saleID?: string | null,
    creator?: string | null,
    customerID?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteRequestToPayMutationVariables = {
  input: DeleteRequestToPayInput,
  condition?: ModelRequestToPayConditionInput | null,
};

export type DeleteRequestToPayMutation = {
  deleteRequestToPay?:  {
    __typename: "RequestToPay",
    id: string,
    orderID?: string | null,
    expirationTime?: number | null,
    createdAt: string,
    saleID?: string | null,
    creator?: string | null,
    customerID?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateSaleMutationVariables = {
  input: CreateSaleInput,
  condition?: ModelSaleConditionInput | null,
};

export type CreateSaleMutation = {
  createSale?:  {
    __typename: "Sale",
    id: string,
    username?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    branch?: string | null,
    baskets?:  {
      __typename: "ModelBasketConnection",
      nextToken?: string | null,
    } | null,
    customers?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSaleMutationVariables = {
  input: UpdateSaleInput,
  condition?: ModelSaleConditionInput | null,
};

export type UpdateSaleMutation = {
  updateSale?:  {
    __typename: "Sale",
    id: string,
    username?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    branch?: string | null,
    baskets?:  {
      __typename: "ModelBasketConnection",
      nextToken?: string | null,
    } | null,
    customers?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSaleMutationVariables = {
  input: DeleteSaleInput,
  condition?: ModelSaleConditionInput | null,
};

export type DeleteSaleMutation = {
  deleteSale?:  {
    __typename: "Sale",
    id: string,
    username?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    branch?: string | null,
    baskets?:  {
      __typename: "ModelBasketConnection",
      nextToken?: string | null,
    } | null,
    customers?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateBasketMutationVariables = {
  input: CreateBasketInput,
  condition?: ModelBasketConditionInput | null,
};

export type CreateBasketMutation = {
  createBasket?:  {
    __typename: "Basket",
    id: string,
    basketID: string,
    saleID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBasketMutationVariables = {
  input: UpdateBasketInput,
  condition?: ModelBasketConditionInput | null,
};

export type UpdateBasketMutation = {
  updateBasket?:  {
    __typename: "Basket",
    id: string,
    basketID: string,
    saleID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBasketMutationVariables = {
  input: DeleteBasketInput,
  condition?: ModelBasketConditionInput | null,
};

export type DeleteBasketMutation = {
  deleteBasket?:  {
    __typename: "Basket",
    id: string,
    basketID: string,
    saleID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAddressMutationVariables = {
  input: CreateAddressInput,
  condition?: ModelAddressConditionInput | null,
};

export type CreateAddressMutation = {
  createAddress?:  {
    __typename: "Address",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAddressMutationVariables = {
  input: UpdateAddressInput,
  condition?: ModelAddressConditionInput | null,
};

export type UpdateAddressMutation = {
  updateAddress?:  {
    __typename: "Address",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAddressMutationVariables = {
  input: DeleteAddressInput,
  condition?: ModelAddressConditionInput | null,
};

export type DeleteAddressMutation = {
  deleteAddress?:  {
    __typename: "Address",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTaxInvoiceAddressMutationVariables = {
  input: CreateTaxInvoiceAddressInput,
  condition?: ModelTaxInvoiceAddressConditionInput | null,
};

export type CreateTaxInvoiceAddressMutation = {
  createTaxInvoiceAddress?:  {
    __typename: "TaxInvoiceAddress",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    companyName?: string | null,
    companyBranch?: string | null,
    taxID?: string | null,
    isDefault?: boolean | null,
    requestTaxInvoice?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTaxInvoiceAddressMutationVariables = {
  input: UpdateTaxInvoiceAddressInput,
  condition?: ModelTaxInvoiceAddressConditionInput | null,
};

export type UpdateTaxInvoiceAddressMutation = {
  updateTaxInvoiceAddress?:  {
    __typename: "TaxInvoiceAddress",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    companyName?: string | null,
    companyBranch?: string | null,
    taxID?: string | null,
    isDefault?: boolean | null,
    requestTaxInvoice?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTaxInvoiceAddressMutationVariables = {
  input: DeleteTaxInvoiceAddressInput,
  condition?: ModelTaxInvoiceAddressConditionInput | null,
};

export type DeleteTaxInvoiceAddressMutation = {
  deleteTaxInvoiceAddress?:  {
    __typename: "TaxInvoiceAddress",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    companyName?: string | null,
    companyBranch?: string | null,
    taxID?: string | null,
    isDefault?: boolean | null,
    requestTaxInvoice?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCustomerMutationVariables = {
  input: CreateCustomerInput,
  condition?: ModelCustomerConditionInput | null,
};

export type CreateCustomerMutation = {
  createCustomer?:  {
    __typename: "Customer",
    id: string,
    customerID?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    address?:  {
      __typename: "ModelAddressConnection",
      nextToken?: string | null,
    } | null,
    taxInvoice?:  {
      __typename: "ModelTaxInvoiceAddressConnection",
      nextToken?: string | null,
    } | null,
    phone_number?: string | null,
    basketID?: string | null,
    sales?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCustomerMutationVariables = {
  input: UpdateCustomerInput,
  condition?: ModelCustomerConditionInput | null,
};

export type UpdateCustomerMutation = {
  updateCustomer?:  {
    __typename: "Customer",
    id: string,
    customerID?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    address?:  {
      __typename: "ModelAddressConnection",
      nextToken?: string | null,
    } | null,
    taxInvoice?:  {
      __typename: "ModelTaxInvoiceAddressConnection",
      nextToken?: string | null,
    } | null,
    phone_number?: string | null,
    basketID?: string | null,
    sales?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCustomerMutationVariables = {
  input: DeleteCustomerInput,
  condition?: ModelCustomerConditionInput | null,
};

export type DeleteCustomerMutation = {
  deleteCustomer?:  {
    __typename: "Customer",
    id: string,
    customerID?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    address?:  {
      __typename: "ModelAddressConnection",
      nextToken?: string | null,
    } | null,
    taxInvoice?:  {
      __typename: "ModelTaxInvoiceAddressConnection",
      nextToken?: string | null,
    } | null,
    phone_number?: string | null,
    basketID?: string | null,
    sales?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDraftOrderMutationVariables = {
  input: CreateDraftOrderInput,
  condition?: ModelDraftOrderConditionInput | null,
};

export type CreateDraftOrderMutation = {
  createDraftOrder?:  {
    __typename: "DraftOrder",
    id: string,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDraftOrderMutationVariables = {
  input: UpdateDraftOrderInput,
  condition?: ModelDraftOrderConditionInput | null,
};

export type UpdateDraftOrderMutation = {
  updateDraftOrder?:  {
    __typename: "DraftOrder",
    id: string,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDraftOrderMutationVariables = {
  input: DeleteDraftOrderInput,
  condition?: ModelDraftOrderConditionInput | null,
};

export type DeleteDraftOrderMutation = {
  deleteDraftOrder?:  {
    __typename: "DraftOrder",
    id: string,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSaleStatMutationVariables = {
  input: CreateSaleStatInput,
  condition?: ModelSaleStatConditionInput | null,
};

export type CreateSaleStatMutation = {
  createSaleStat?:  {
    __typename: "SaleStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    totalCustomer?: number | null,
    sale?:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSaleStatMutationVariables = {
  input: UpdateSaleStatInput,
  condition?: ModelSaleStatConditionInput | null,
};

export type UpdateSaleStatMutation = {
  updateSaleStat?:  {
    __typename: "SaleStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    totalCustomer?: number | null,
    sale?:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSaleStatMutationVariables = {
  input: DeleteSaleStatInput,
  condition?: ModelSaleStatConditionInput | null,
};

export type DeleteSaleStatMutation = {
  deleteSaleStat?:  {
    __typename: "SaleStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    totalCustomer?: number | null,
    sale?:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSaleCustomerStatMutationVariables = {
  input: CreateSaleCustomerStatInput,
  condition?: ModelSaleCustomerStatConditionInput | null,
};

export type CreateSaleCustomerStatMutation = {
  createSaleCustomerStat?:  {
    __typename: "SaleCustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    saleID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSaleCustomerStatMutationVariables = {
  input: UpdateSaleCustomerStatInput,
  condition?: ModelSaleCustomerStatConditionInput | null,
};

export type UpdateSaleCustomerStatMutation = {
  updateSaleCustomerStat?:  {
    __typename: "SaleCustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    saleID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSaleCustomerStatMutationVariables = {
  input: DeleteSaleCustomerStatInput,
  condition?: ModelSaleCustomerStatConditionInput | null,
};

export type DeleteSaleCustomerStatMutation = {
  deleteSaleCustomerStat?:  {
    __typename: "SaleCustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    saleID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCustomerStatMutationVariables = {
  input: CreateCustomerStatInput,
  condition?: ModelCustomerStatConditionInput | null,
};

export type CreateCustomerStatMutation = {
  createCustomerStat?:  {
    __typename: "CustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    customer?:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCustomerStatMutationVariables = {
  input: UpdateCustomerStatInput,
  condition?: ModelCustomerStatConditionInput | null,
};

export type UpdateCustomerStatMutation = {
  updateCustomerStat?:  {
    __typename: "CustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    customer?:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCustomerStatMutationVariables = {
  input: DeleteCustomerStatInput,
  condition?: ModelCustomerStatConditionInput | null,
};

export type DeleteCustomerStatMutation = {
  deleteCustomerStat?:  {
    __typename: "CustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    customer?:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrderIDMutationVariables = {
  input: CreateOrderIDInput,
  condition?: ModelOrderIDConditionInput | null,
};

export type CreateOrderIDMutation = {
  createOrderID?:  {
    __typename: "OrderID",
    key: string,
    counter: number,
    lastEdited: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOrderIDMutationVariables = {
  input: UpdateOrderIDInput,
  condition?: ModelOrderIDConditionInput | null,
};

export type UpdateOrderIDMutation = {
  updateOrderID?:  {
    __typename: "OrderID",
    key: string,
    counter: number,
    lastEdited: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOrderIDMutationVariables = {
  input: DeleteOrderIDInput,
  condition?: ModelOrderIDConditionInput | null,
};

export type DeleteOrderIDMutation = {
  deleteOrderID?:  {
    __typename: "OrderID",
    key: string,
    counter: number,
    lastEdited: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSaleCustomersMutationVariables = {
  input: CreateSaleCustomersInput,
  condition?: ModelSaleCustomersConditionInput | null,
};

export type CreateSaleCustomersMutation = {
  createSaleCustomers?:  {
    __typename: "SaleCustomers",
    id: string,
    saleID: string,
    customerID: string,
    sale:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    customer:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSaleCustomersMutationVariables = {
  input: UpdateSaleCustomersInput,
  condition?: ModelSaleCustomersConditionInput | null,
};

export type UpdateSaleCustomersMutation = {
  updateSaleCustomers?:  {
    __typename: "SaleCustomers",
    id: string,
    saleID: string,
    customerID: string,
    sale:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    customer:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSaleCustomersMutationVariables = {
  input: DeleteSaleCustomersInput,
  condition?: ModelSaleCustomersConditionInput | null,
};

export type DeleteSaleCustomersMutation = {
  deleteSaleCustomers?:  {
    __typename: "SaleCustomers",
    id: string,
    saleID: string,
    customerID: string,
    sale:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    customer:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type GetOrderQueryVariables = {
};

export type GetOrderQuery = {
  getOrder?:  {
    __typename: "Order",
    orderId?: string | null,
  } | null,
};

export type GetRequestToPayQueryVariables = {
  id: string,
};

export type GetRequestToPayQuery = {
  getRequestToPay?:  {
    __typename: "RequestToPay",
    id: string,
    orderID?: string | null,
    expirationTime?: number | null,
    createdAt: string,
    saleID?: string | null,
    creator?: string | null,
    customerID?: string | null,
    updatedAt: string,
  } | null,
};

export type ListRequestToPaysQueryVariables = {
  filter?: ModelRequestToPayFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRequestToPaysQuery = {
  listRequestToPays?:  {
    __typename: "ModelRequestToPayConnection",
    items:  Array< {
      __typename: "RequestToPay",
      id: string,
      orderID?: string | null,
      expirationTime?: number | null,
      createdAt: string,
      saleID?: string | null,
      creator?: string | null,
      customerID?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RequestToPayByOrderIDQueryVariables = {
  orderID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRequestToPayFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RequestToPayByOrderIDQuery = {
  requestToPayByOrderID?:  {
    __typename: "ModelRequestToPayConnection",
    items:  Array< {
      __typename: "RequestToPay",
      id: string,
      orderID?: string | null,
      expirationTime?: number | null,
      createdAt: string,
      saleID?: string | null,
      creator?: string | null,
      customerID?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RequestToPayBySaleIDQueryVariables = {
  saleID: string,
  expirationTime?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRequestToPayFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RequestToPayBySaleIDQuery = {
  requestToPayBySaleID?:  {
    __typename: "ModelRequestToPayConnection",
    items:  Array< {
      __typename: "RequestToPay",
      id: string,
      orderID?: string | null,
      expirationTime?: number | null,
      createdAt: string,
      saleID?: string | null,
      creator?: string | null,
      customerID?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RequestToPayBySaleIDAndCreatedAtQueryVariables = {
  saleID: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRequestToPayFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RequestToPayBySaleIDAndCreatedAtQuery = {
  requestToPayBySaleIDAndCreatedAt?:  {
    __typename: "ModelRequestToPayConnection",
    items:  Array< {
      __typename: "RequestToPay",
      id: string,
      orderID?: string | null,
      expirationTime?: number | null,
      createdAt: string,
      saleID?: string | null,
      creator?: string | null,
      customerID?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RequestToPayByCreatorQueryVariables = {
  creator: string,
  expirationTime?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRequestToPayFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RequestToPayByCreatorQuery = {
  requestToPayByCreator?:  {
    __typename: "ModelRequestToPayConnection",
    items:  Array< {
      __typename: "RequestToPay",
      id: string,
      orderID?: string | null,
      expirationTime?: number | null,
      createdAt: string,
      saleID?: string | null,
      creator?: string | null,
      customerID?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RequestToPayByCustomerIDQueryVariables = {
  customerID: string,
  expirationTime?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRequestToPayFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RequestToPayByCustomerIDQuery = {
  requestToPayByCustomerID?:  {
    __typename: "ModelRequestToPayConnection",
    items:  Array< {
      __typename: "RequestToPay",
      id: string,
      orderID?: string | null,
      expirationTime?: number | null,
      createdAt: string,
      saleID?: string | null,
      creator?: string | null,
      customerID?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSaleQueryVariables = {
  id: string,
};

export type GetSaleQuery = {
  getSale?:  {
    __typename: "Sale",
    id: string,
    username?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    branch?: string | null,
    baskets?:  {
      __typename: "ModelBasketConnection",
      nextToken?: string | null,
    } | null,
    customers?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSalesQueryVariables = {
  filter?: ModelSaleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSalesQuery = {
  listSales?:  {
    __typename: "ModelSaleConnection",
    items:  Array< {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBasketQueryVariables = {
  id: string,
};

export type GetBasketQuery = {
  getBasket?:  {
    __typename: "Basket",
    id: string,
    basketID: string,
    saleID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBasketsQueryVariables = {
  filter?: ModelBasketFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBasketsQuery = {
  listBaskets?:  {
    __typename: "ModelBasketConnection",
    items:  Array< {
      __typename: "Basket",
      id: string,
      basketID: string,
      saleID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAddressQueryVariables = {
  id: string,
};

export type GetAddressQuery = {
  getAddress?:  {
    __typename: "Address",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAddressesQueryVariables = {
  filter?: ModelAddressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAddressesQuery = {
  listAddresses?:  {
    __typename: "ModelAddressConnection",
    items:  Array< {
      __typename: "Address",
      id?: string | null,
      customerID: string,
      address?: string | null,
      district?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      name?: string | null,
      phone?: string | null,
      postcode?: string | null,
      subDistrict?: string | null,
      province?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTaxInvoiceAddressQueryVariables = {
  id: string,
};

export type GetTaxInvoiceAddressQuery = {
  getTaxInvoiceAddress?:  {
    __typename: "TaxInvoiceAddress",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    companyName?: string | null,
    companyBranch?: string | null,
    taxID?: string | null,
    isDefault?: boolean | null,
    requestTaxInvoice?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTaxInvoiceAddressesQueryVariables = {
  filter?: ModelTaxInvoiceAddressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaxInvoiceAddressesQuery = {
  listTaxInvoiceAddresses?:  {
    __typename: "ModelTaxInvoiceAddressConnection",
    items:  Array< {
      __typename: "TaxInvoiceAddress",
      id?: string | null,
      customerID: string,
      address?: string | null,
      district?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      name?: string | null,
      phone?: string | null,
      postcode?: string | null,
      subDistrict?: string | null,
      province?: string | null,
      companyName?: string | null,
      companyBranch?: string | null,
      taxID?: string | null,
      isDefault?: boolean | null,
      requestTaxInvoice?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCustomerQueryVariables = {
  id: string,
};

export type GetCustomerQuery = {
  getCustomer?:  {
    __typename: "Customer",
    id: string,
    customerID?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    address?:  {
      __typename: "ModelAddressConnection",
      nextToken?: string | null,
    } | null,
    taxInvoice?:  {
      __typename: "ModelTaxInvoiceAddressConnection",
      nextToken?: string | null,
    } | null,
    phone_number?: string | null,
    basketID?: string | null,
    sales?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCustomersQueryVariables = {
  filter?: ModelCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCustomersQuery = {
  listCustomers?:  {
    __typename: "ModelCustomerConnection",
    items:  Array< {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomerByCustomerIDQueryVariables = {
  customerID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomerByCustomerIDQuery = {
  customerByCustomerID?:  {
    __typename: "ModelCustomerConnection",
    items:  Array< {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomerByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomerByEmailQuery = {
  customerByEmail?:  {
    __typename: "ModelCustomerConnection",
    items:  Array< {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomerByPhoneQueryVariables = {
  phone_number: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomerByPhoneQuery = {
  customerByPhone?:  {
    __typename: "ModelCustomerConnection",
    items:  Array< {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDraftOrderQueryVariables = {
  id: string,
};

export type GetDraftOrderQuery = {
  getDraftOrder?:  {
    __typename: "DraftOrder",
    id: string,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDraftOrdersQueryVariables = {
  filter?: ModelDraftOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDraftOrdersQuery = {
  listDraftOrders?:  {
    __typename: "ModelDraftOrderConnection",
    items:  Array< {
      __typename: "DraftOrder",
      id: string,
      data?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSaleStatQueryVariables = {
  id: string,
  granularity: Granularity,
  timestamp: number,
};

export type GetSaleStatQuery = {
  getSaleStat?:  {
    __typename: "SaleStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    totalCustomer?: number | null,
    sale?:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSaleStatsQueryVariables = {
  id?: string | null,
  granularityTimestamp?: ModelSaleStatPrimaryCompositeKeyConditionInput | null,
  filter?: ModelSaleStatFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSaleStatsQuery = {
  listSaleStats?:  {
    __typename: "ModelSaleStatConnection",
    items:  Array< {
      __typename: "SaleStat",
      id: string,
      timestamp: number,
      granularity: Granularity,
      totalSaleVolume?: number | null,
      totalOrder?: number | null,
      totalCustomer?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SaleStatByGranularityAndTimestampQueryVariables = {
  id: string,
  granularityTimestamp?: ModelSaleStatByIDWithGranularityCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSaleStatFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SaleStatByGranularityAndTimestampQuery = {
  saleStatByGranularityAndTimestamp?:  {
    __typename: "ModelSaleStatConnection",
    items:  Array< {
      __typename: "SaleStat",
      id: string,
      timestamp: number,
      granularity: Granularity,
      totalSaleVolume?: number | null,
      totalOrder?: number | null,
      totalCustomer?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SaleStatByGranularityWithTimestampQueryVariables = {
  granularity: Granularity,
  timestamp?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSaleStatFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SaleStatByGranularityWithTimestampQuery = {
  saleStatByGranularityWithTimestamp?:  {
    __typename: "ModelSaleStatConnection",
    items:  Array< {
      __typename: "SaleStat",
      id: string,
      timestamp: number,
      granularity: Granularity,
      totalSaleVolume?: number | null,
      totalOrder?: number | null,
      totalCustomer?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSaleCustomerStatQueryVariables = {
  id: string,
  granularity: Granularity,
  timestamp: number,
};

export type GetSaleCustomerStatQuery = {
  getSaleCustomerStat?:  {
    __typename: "SaleCustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    saleID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSaleCustomerStatsQueryVariables = {
  id?: string | null,
  granularityTimestamp?: ModelSaleCustomerStatPrimaryCompositeKeyConditionInput | null,
  filter?: ModelSaleCustomerStatFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSaleCustomerStatsQuery = {
  listSaleCustomerStats?:  {
    __typename: "ModelSaleCustomerStatConnection",
    items:  Array< {
      __typename: "SaleCustomerStat",
      id: string,
      timestamp: number,
      granularity: Granularity,
      totalSaleVolume?: number | null,
      totalOrder?: number | null,
      productList?: Array< string | null > | null,
      orderList?: Array< string | null > | null,
      saleID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SaleCustomerStatByGranularityAndTimestampQueryVariables = {
  id: string,
  granularityTimestamp?: ModelSaleCustomerStatByIDWithGranularityCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSaleCustomerStatFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SaleCustomerStatByGranularityAndTimestampQuery = {
  saleCustomerStatByGranularityAndTimestamp?:  {
    __typename: "ModelSaleCustomerStatConnection",
    items:  Array< {
      __typename: "SaleCustomerStat",
      id: string,
      timestamp: number,
      granularity: Granularity,
      totalSaleVolume?: number | null,
      totalOrder?: number | null,
      productList?: Array< string | null > | null,
      orderList?: Array< string | null > | null,
      saleID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SaleCustomerStatByGranularityWithTimestampQueryVariables = {
  granularity: Granularity,
  timestamp?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSaleCustomerStatFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SaleCustomerStatByGranularityWithTimestampQuery = {
  saleCustomerStatByGranularityWithTimestamp?:  {
    __typename: "ModelSaleCustomerStatConnection",
    items:  Array< {
      __typename: "SaleCustomerStat",
      id: string,
      timestamp: number,
      granularity: Granularity,
      totalSaleVolume?: number | null,
      totalOrder?: number | null,
      productList?: Array< string | null > | null,
      orderList?: Array< string | null > | null,
      saleID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SaleCustomerStatBySaleIDAndGranularityAndTimestampQueryVariables = {
  saleID: string,
  granularityTimestamp?: ModelSaleCustomerStatBySaleIDWithGranularityAndTimestampCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSaleCustomerStatFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SaleCustomerStatBySaleIDAndGranularityAndTimestampQuery = {
  saleCustomerStatBySaleIDAndGranularityAndTimestamp?:  {
    __typename: "ModelSaleCustomerStatConnection",
    items:  Array< {
      __typename: "SaleCustomerStat",
      id: string,
      timestamp: number,
      granularity: Granularity,
      totalSaleVolume?: number | null,
      totalOrder?: number | null,
      productList?: Array< string | null > | null,
      orderList?: Array< string | null > | null,
      saleID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCustomerStatQueryVariables = {
  id: string,
  granularity: Granularity,
  timestamp: number,
};

export type GetCustomerStatQuery = {
  getCustomerStat?:  {
    __typename: "CustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    customer?:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCustomerStatsQueryVariables = {
  id?: string | null,
  granularityTimestamp?: ModelCustomerStatPrimaryCompositeKeyConditionInput | null,
  filter?: ModelCustomerStatFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCustomerStatsQuery = {
  listCustomerStats?:  {
    __typename: "ModelCustomerStatConnection",
    items:  Array< {
      __typename: "CustomerStat",
      id: string,
      timestamp: number,
      granularity: Granularity,
      totalSaleVolume?: number | null,
      totalOrder?: number | null,
      productList?: Array< string | null > | null,
      orderList?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomerStatByGranularityAndTimestampQueryVariables = {
  id: string,
  granularityTimestamp?: ModelCustomerStatByIDWithGranularityCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCustomerStatFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomerStatByGranularityAndTimestampQuery = {
  customerStatByGranularityAndTimestamp?:  {
    __typename: "ModelCustomerStatConnection",
    items:  Array< {
      __typename: "CustomerStat",
      id: string,
      timestamp: number,
      granularity: Granularity,
      totalSaleVolume?: number | null,
      totalOrder?: number | null,
      productList?: Array< string | null > | null,
      orderList?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomerStatByGranularityWithTimestampQueryVariables = {
  granularity: Granularity,
  timestamp?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCustomerStatFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomerStatByGranularityWithTimestampQuery = {
  customerStatByGranularityWithTimestamp?:  {
    __typename: "ModelCustomerStatConnection",
    items:  Array< {
      __typename: "CustomerStat",
      id: string,
      timestamp: number,
      granularity: Granularity,
      totalSaleVolume?: number | null,
      totalOrder?: number | null,
      productList?: Array< string | null > | null,
      orderList?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrderIDQueryVariables = {
  key: string,
};

export type GetOrderIDQuery = {
  getOrderID?:  {
    __typename: "OrderID",
    key: string,
    counter: number,
    lastEdited: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOrderIDSQueryVariables = {
  key?: string | null,
  filter?: ModelOrderIDFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListOrderIDSQuery = {
  listOrderIDS?:  {
    __typename: "ModelOrderIDConnection",
    items:  Array< {
      __typename: "OrderID",
      key: string,
      counter: number,
      lastEdited: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSaleCustomersQueryVariables = {
  id: string,
};

export type GetSaleCustomersQuery = {
  getSaleCustomers?:  {
    __typename: "SaleCustomers",
    id: string,
    saleID: string,
    customerID: string,
    sale:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    customer:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSaleCustomersQueryVariables = {
  filter?: ModelSaleCustomersFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSaleCustomersQuery = {
  listSaleCustomers?:  {
    __typename: "ModelSaleCustomersConnection",
    items:  Array< {
      __typename: "SaleCustomers",
      id: string,
      saleID: string,
      customerID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreateRequestToPaySubscriptionVariables = {
  filter?: ModelSubscriptionRequestToPayFilterInput | null,
};

export type OnCreateRequestToPaySubscription = {
  onCreateRequestToPay?:  {
    __typename: "RequestToPay",
    id: string,
    orderID?: string | null,
    expirationTime?: number | null,
    createdAt: string,
    saleID?: string | null,
    creator?: string | null,
    customerID?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateRequestToPaySubscriptionVariables = {
  filter?: ModelSubscriptionRequestToPayFilterInput | null,
};

export type OnUpdateRequestToPaySubscription = {
  onUpdateRequestToPay?:  {
    __typename: "RequestToPay",
    id: string,
    orderID?: string | null,
    expirationTime?: number | null,
    createdAt: string,
    saleID?: string | null,
    creator?: string | null,
    customerID?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteRequestToPaySubscriptionVariables = {
  filter?: ModelSubscriptionRequestToPayFilterInput | null,
};

export type OnDeleteRequestToPaySubscription = {
  onDeleteRequestToPay?:  {
    __typename: "RequestToPay",
    id: string,
    orderID?: string | null,
    expirationTime?: number | null,
    createdAt: string,
    saleID?: string | null,
    creator?: string | null,
    customerID?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateSaleSubscriptionVariables = {
  filter?: ModelSubscriptionSaleFilterInput | null,
};

export type OnCreateSaleSubscription = {
  onCreateSale?:  {
    __typename: "Sale",
    id: string,
    username?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    branch?: string | null,
    baskets?:  {
      __typename: "ModelBasketConnection",
      nextToken?: string | null,
    } | null,
    customers?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSaleSubscriptionVariables = {
  filter?: ModelSubscriptionSaleFilterInput | null,
};

export type OnUpdateSaleSubscription = {
  onUpdateSale?:  {
    __typename: "Sale",
    id: string,
    username?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    branch?: string | null,
    baskets?:  {
      __typename: "ModelBasketConnection",
      nextToken?: string | null,
    } | null,
    customers?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSaleSubscriptionVariables = {
  filter?: ModelSubscriptionSaleFilterInput | null,
};

export type OnDeleteSaleSubscription = {
  onDeleteSale?:  {
    __typename: "Sale",
    id: string,
    username?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    branch?: string | null,
    baskets?:  {
      __typename: "ModelBasketConnection",
      nextToken?: string | null,
    } | null,
    customers?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateBasketSubscriptionVariables = {
  filter?: ModelSubscriptionBasketFilterInput | null,
};

export type OnCreateBasketSubscription = {
  onCreateBasket?:  {
    __typename: "Basket",
    id: string,
    basketID: string,
    saleID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBasketSubscriptionVariables = {
  filter?: ModelSubscriptionBasketFilterInput | null,
};

export type OnUpdateBasketSubscription = {
  onUpdateBasket?:  {
    __typename: "Basket",
    id: string,
    basketID: string,
    saleID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBasketSubscriptionVariables = {
  filter?: ModelSubscriptionBasketFilterInput | null,
};

export type OnDeleteBasketSubscription = {
  onDeleteBasket?:  {
    __typename: "Basket",
    id: string,
    basketID: string,
    saleID: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAddressSubscriptionVariables = {
  filter?: ModelSubscriptionAddressFilterInput | null,
};

export type OnCreateAddressSubscription = {
  onCreateAddress?:  {
    __typename: "Address",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAddressSubscriptionVariables = {
  filter?: ModelSubscriptionAddressFilterInput | null,
};

export type OnUpdateAddressSubscription = {
  onUpdateAddress?:  {
    __typename: "Address",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAddressSubscriptionVariables = {
  filter?: ModelSubscriptionAddressFilterInput | null,
};

export type OnDeleteAddressSubscription = {
  onDeleteAddress?:  {
    __typename: "Address",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTaxInvoiceAddressSubscriptionVariables = {
  filter?: ModelSubscriptionTaxInvoiceAddressFilterInput | null,
};

export type OnCreateTaxInvoiceAddressSubscription = {
  onCreateTaxInvoiceAddress?:  {
    __typename: "TaxInvoiceAddress",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    companyName?: string | null,
    companyBranch?: string | null,
    taxID?: string | null,
    isDefault?: boolean | null,
    requestTaxInvoice?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTaxInvoiceAddressSubscriptionVariables = {
  filter?: ModelSubscriptionTaxInvoiceAddressFilterInput | null,
};

export type OnUpdateTaxInvoiceAddressSubscription = {
  onUpdateTaxInvoiceAddress?:  {
    __typename: "TaxInvoiceAddress",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    companyName?: string | null,
    companyBranch?: string | null,
    taxID?: string | null,
    isDefault?: boolean | null,
    requestTaxInvoice?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTaxInvoiceAddressSubscriptionVariables = {
  filter?: ModelSubscriptionTaxInvoiceAddressFilterInput | null,
};

export type OnDeleteTaxInvoiceAddressSubscription = {
  onDeleteTaxInvoiceAddress?:  {
    __typename: "TaxInvoiceAddress",
    id?: string | null,
    customerID: string,
    address?: string | null,
    district?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    name?: string | null,
    phone?: string | null,
    postcode?: string | null,
    subDistrict?: string | null,
    province?: string | null,
    location?:  {
      __typename: "Location",
      lat?: number | null,
      lng?: number | null,
    } | null,
    companyName?: string | null,
    companyBranch?: string | null,
    taxID?: string | null,
    isDefault?: boolean | null,
    requestTaxInvoice?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCustomerSubscriptionVariables = {
  filter?: ModelSubscriptionCustomerFilterInput | null,
};

export type OnCreateCustomerSubscription = {
  onCreateCustomer?:  {
    __typename: "Customer",
    id: string,
    customerID?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    address?:  {
      __typename: "ModelAddressConnection",
      nextToken?: string | null,
    } | null,
    taxInvoice?:  {
      __typename: "ModelTaxInvoiceAddressConnection",
      nextToken?: string | null,
    } | null,
    phone_number?: string | null,
    basketID?: string | null,
    sales?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCustomerSubscriptionVariables = {
  filter?: ModelSubscriptionCustomerFilterInput | null,
};

export type OnUpdateCustomerSubscription = {
  onUpdateCustomer?:  {
    __typename: "Customer",
    id: string,
    customerID?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    address?:  {
      __typename: "ModelAddressConnection",
      nextToken?: string | null,
    } | null,
    taxInvoice?:  {
      __typename: "ModelTaxInvoiceAddressConnection",
      nextToken?: string | null,
    } | null,
    phone_number?: string | null,
    basketID?: string | null,
    sales?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCustomerSubscriptionVariables = {
  filter?: ModelSubscriptionCustomerFilterInput | null,
};

export type OnDeleteCustomerSubscription = {
  onDeleteCustomer?:  {
    __typename: "Customer",
    id: string,
    customerID?: string | null,
    email?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    address?:  {
      __typename: "ModelAddressConnection",
      nextToken?: string | null,
    } | null,
    taxInvoice?:  {
      __typename: "ModelTaxInvoiceAddressConnection",
      nextToken?: string | null,
    } | null,
    phone_number?: string | null,
    basketID?: string | null,
    sales?:  {
      __typename: "ModelSaleCustomersConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateDraftOrderSubscriptionVariables = {
  filter?: ModelSubscriptionDraftOrderFilterInput | null,
};

export type OnCreateDraftOrderSubscription = {
  onCreateDraftOrder?:  {
    __typename: "DraftOrder",
    id: string,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateDraftOrderSubscriptionVariables = {
  filter?: ModelSubscriptionDraftOrderFilterInput | null,
};

export type OnUpdateDraftOrderSubscription = {
  onUpdateDraftOrder?:  {
    __typename: "DraftOrder",
    id: string,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteDraftOrderSubscriptionVariables = {
  filter?: ModelSubscriptionDraftOrderFilterInput | null,
};

export type OnDeleteDraftOrderSubscription = {
  onDeleteDraftOrder?:  {
    __typename: "DraftOrder",
    id: string,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateSaleStatSubscriptionVariables = {
  filter?: ModelSubscriptionSaleStatFilterInput | null,
};

export type OnCreateSaleStatSubscription = {
  onCreateSaleStat?:  {
    __typename: "SaleStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    totalCustomer?: number | null,
    sale?:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSaleStatSubscriptionVariables = {
  filter?: ModelSubscriptionSaleStatFilterInput | null,
};

export type OnUpdateSaleStatSubscription = {
  onUpdateSaleStat?:  {
    __typename: "SaleStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    totalCustomer?: number | null,
    sale?:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSaleStatSubscriptionVariables = {
  filter?: ModelSubscriptionSaleStatFilterInput | null,
};

export type OnDeleteSaleStatSubscription = {
  onDeleteSaleStat?:  {
    __typename: "SaleStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    totalCustomer?: number | null,
    sale?:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateSaleCustomerStatSubscriptionVariables = {
  filter?: ModelSubscriptionSaleCustomerStatFilterInput | null,
};

export type OnCreateSaleCustomerStatSubscription = {
  onCreateSaleCustomerStat?:  {
    __typename: "SaleCustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    saleID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSaleCustomerStatSubscriptionVariables = {
  filter?: ModelSubscriptionSaleCustomerStatFilterInput | null,
};

export type OnUpdateSaleCustomerStatSubscription = {
  onUpdateSaleCustomerStat?:  {
    __typename: "SaleCustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    saleID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSaleCustomerStatSubscriptionVariables = {
  filter?: ModelSubscriptionSaleCustomerStatFilterInput | null,
};

export type OnDeleteSaleCustomerStatSubscription = {
  onDeleteSaleCustomerStat?:  {
    __typename: "SaleCustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    saleID?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCustomerStatSubscriptionVariables = {
  filter?: ModelSubscriptionCustomerStatFilterInput | null,
};

export type OnCreateCustomerStatSubscription = {
  onCreateCustomerStat?:  {
    __typename: "CustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    customer?:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCustomerStatSubscriptionVariables = {
  filter?: ModelSubscriptionCustomerStatFilterInput | null,
};

export type OnUpdateCustomerStatSubscription = {
  onUpdateCustomerStat?:  {
    __typename: "CustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    customer?:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCustomerStatSubscriptionVariables = {
  filter?: ModelSubscriptionCustomerStatFilterInput | null,
};

export type OnDeleteCustomerStatSubscription = {
  onDeleteCustomerStat?:  {
    __typename: "CustomerStat",
    id: string,
    timestamp: number,
    granularity: Granularity,
    totalSaleVolume?: number | null,
    totalOrder?: number | null,
    productList?: Array< string | null > | null,
    orderList?: Array< string | null > | null,
    customer?:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateOrderIDSubscriptionVariables = {
  filter?: ModelSubscriptionOrderIDFilterInput | null,
};

export type OnCreateOrderIDSubscription = {
  onCreateOrderID?:  {
    __typename: "OrderID",
    key: string,
    counter: number,
    lastEdited: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrderIDSubscriptionVariables = {
  filter?: ModelSubscriptionOrderIDFilterInput | null,
};

export type OnUpdateOrderIDSubscription = {
  onUpdateOrderID?:  {
    __typename: "OrderID",
    key: string,
    counter: number,
    lastEdited: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrderIDSubscriptionVariables = {
  filter?: ModelSubscriptionOrderIDFilterInput | null,
};

export type OnDeleteOrderIDSubscription = {
  onDeleteOrderID?:  {
    __typename: "OrderID",
    key: string,
    counter: number,
    lastEdited: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateSaleCustomersSubscriptionVariables = {
  filter?: ModelSubscriptionSaleCustomersFilterInput | null,
};

export type OnCreateSaleCustomersSubscription = {
  onCreateSaleCustomers?:  {
    __typename: "SaleCustomers",
    id: string,
    saleID: string,
    customerID: string,
    sale:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    customer:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSaleCustomersSubscriptionVariables = {
  filter?: ModelSubscriptionSaleCustomersFilterInput | null,
};

export type OnUpdateSaleCustomersSubscription = {
  onUpdateSaleCustomers?:  {
    __typename: "SaleCustomers",
    id: string,
    saleID: string,
    customerID: string,
    sale:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    customer:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSaleCustomersSubscriptionVariables = {
  filter?: ModelSubscriptionSaleCustomersFilterInput | null,
};

export type OnDeleteSaleCustomersSubscription = {
  onDeleteSaleCustomers?:  {
    __typename: "SaleCustomers",
    id: string,
    saleID: string,
    customerID: string,
    sale:  {
      __typename: "Sale",
      id: string,
      username?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      branch?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    customer:  {
      __typename: "Customer",
      id: string,
      customerID?: string | null,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      phone_number?: string | null,
      basketID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};
